import { useEffect, useState } from "react";
import { LoginPage } from "./pages/LoginPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { Shell } from "./pages/Shell";
import { PortalApp } from "./pages/PortalApp";
import { useAuth } from "./hooks/useAuth";
import { api, IDLE_LIMIT_MS, idleMs, refreshSession } from "./lib/api";

/** Portal do cliente (/portal/<escritório>) é um app à parte: sem sessão do escritório. */
export function App(): JSX.Element {
  const m = /^\/portal\/([\w-]+)/.exec(window.location.pathname);
  if (m) return <PortalApp slug={m[1]!} />;
  return <StaffApp />;
}

function StaffApp(): JSX.Element {
  const { session, restoring, setRestoring } = useAuth();
  const [resetToken, setResetToken] = useState<string | null>(
    () => new URLSearchParams(window.location.search).get("reset"),
  );

  // Ao abrir a página, tenta restaurar a sessão pelo cookie httpOnly.
  useEffect(() => {
    if (resetToken) { setRestoring(false); return; }
    void refreshSession().finally(() => setRestoring(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Sessão comum: encerra após 4h sem atividade na tela (o servidor também confere).
  const [idleOut, setIdleOut] = useState(false);
  useEffect(() => {
    if (!session || session.remember) return;
    const t = setInterval(() => {
      if (idleMs() > IDLE_LIMIT_MS) {
        void api.post("/auth/logout").catch(() => undefined).finally(() => { useAuth.getState().clear(); setIdleOut(true); });
      }
    }, 60_000);
    return () => clearInterval(t);
  }, [session]);

  if (resetToken) {
    return (
      <ResetPasswordPage
        token={resetToken}
        onDone={() => {
          window.history.replaceState(null, "", window.location.pathname);
          setResetToken(null);
        }}
      />
    );
  }
  if (restoring) return <div className="login-wrapper"><div className="muted">Carregando…</div></div>;
  if (session) return <Shell />;
  return (
    <>
      {idleOut && <div className="banner-bad" style={{ position: "fixed", top: 12, left: "50%", transform: "translateX(-50%)", zIndex: 100 }}>Sessão encerrada após 4h sem uso. Entre novamente.</div>}
      <LoginPage />
    </>
  );
}
